import {Injectable} from '@angular/core';
import {Subscription} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SubscriptionContainerService {

  private subs = new Map<string, Subscription>()

  constructor() {
  }

  getKeys(): Map<string, Subscription> {
    return this.subs
  }

  add(key: string, s: Subscription | null) {
    if (key == null || s == null) return
    if (this.subs.has(key)) return
    this.subs.set(key, s)
  }

  hasKey(key: string): boolean {
    return this.subs.has(key)
  }

  dispose() {
    this.subs.forEach(value => value.unsubscribe())
    this.subs.clear()
  }

  disposeSubscription(key: string) {
    this.subs.get(key)?.unsubscribe()
    this.subs.delete(key)
  }

  disposeNonGlobal() {
    this.subs.forEach((value, key) => {
      if (!key.startsWith("global:")) {
        value.unsubscribe()
        this.subs.delete(key)
      }
    })
  }

  disposeForComponent(componentName: string) {
    this.subs.forEach((value, key) => {
      if (key.startsWith(componentName)) {
        value.unsubscribe()
        this.subs.delete(key)
      }
    })
  }
}
